import { StreamSessionInitializationResult } from "src/enums";

const STREAM_INIT_SUPPORTED_RESULTS = [
  StreamSessionInitializationResult.SUCCESS,
  StreamSessionInitializationResult.LOGIN_REQUIRED,
];

export default STREAM_INIT_SUPPORTED_RESULTS;
